import type { ThemeOptions } from '@mui/material/styles';

/** One compact notice treatment for in-component messages. */
export const alertComponents: Pick<NonNullable<ThemeOptions['components']>, 'MuiAlert' | 'MuiAlertTitle'> = {
  MuiAlert: {
    defaultProps: { variant: 'standard' },
    styleOverrides: {
      root: ({ theme, ownerState }) => ({
        ...theme.typography.body3,
        fontWeight: 600,
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(1.25, 1.5),
        gap: theme.spacing(1.25),
        borderRadius: theme.spacing(1),
        border: `1px solid ${theme.palette.neutral[500]}`,
        borderLeft: `2px solid ${theme.palette[ownerState.color ?? ownerState.severity ?? 'info'].main}`,
        backgroundColor: theme.palette.neutral[600],
        backgroundImage: 'none',
        color: theme.palette.neutral[100],
        boxShadow: 'none',
      }),
      icon: ({ theme, ownerState }) => {
        const severity = ownerState.color ?? ownerState.severity ?? 'info';

        return {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
          width: 20,
          height: 20,
          padding: 0,
          margin: 0,
          opacity: 1,
          color: theme.palette[severity].main,
          '& .MuiSvgIcon-root': { fontSize: 20 },
        };
      },
      message: { padding: 0, minWidth: 0, flex: 1, overflowWrap: 'anywhere' },
      action: ({ theme }) => ({
        padding: 0,
        marginRight: 0,
        marginLeft: 0,
        alignSelf: 'center',
        '& .MuiButton-text': {
          ...theme.typography.body3,
          height: 'auto',
          minHeight: 20,
          minWidth: 0,
          padding: theme.spacing(0, 0.75),
          lineHeight: '20px',
          fontWeight: 600,
          color: theme.palette.neutral[100],
          '&:hover': {
            color: theme.palette.neutral[25],
            backgroundColor: theme.palette.neutral[500],
          },
          '&.Mui-disabled': { color: theme.palette.neutral[400] },
        },
      }),
    },
  },
  MuiAlertTitle: {
    styleOverrides: {
      root: ({ theme }) => ({
        ...theme.typography.body3,
        fontWeight: 700,
        color: theme.palette.neutral[25],
        marginTop: 0,
        marginBottom: theme.spacing(0.5),
      }),
    },
  },
};
